import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Cookies from 'js-cookie'

import dayjs from 'dayjs'
require('dayjs/locale/zh-cn')
const duration = require('dayjs/plugin/duration')
const relativeTime = require('dayjs/plugin/relativeTime')
const quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.locale('zh-cn')
Vue.prototype.dayjs = dayjs
import './assets/styles/element-variables.scss'
import './assets/icons' // icon



// global css
import './assets/styles/index.scss'
Vue.config.productionTip = false
Vue.use(ElementUI,{
  size: Cookies.get('size') || 'small' // set element-ui default size
});

import ElTable2 from './components/el-table2.vue'
Vue.component('el-table2', ElTable2)


import oss from './utils/aliyunoss.js'
Vue.prototype.$oss = oss


import _ from 'lodash'
Vue.prototype._ = _
window._ = _

Vue.directive('scoped', function(element, binding) {
  const scopedId = binding.value?.$options?._scopeId
  if (!scopedId) {
    return
  }
  const componentTag = element.__vue__.$vnode.tag
  const target = [] // 需要添加scopedId的元素

  if (componentTag.indexOf('ElPopover') !== -1) {
    // popover组件
    target.push(element.children[0])
  } else if (componentTag.indexOf('ElDialog') !== -1) {
    target.push(element.children[0])
  } else if (componentTag.indexOf('transition') !== -1) {
    target.push(element)
    target.push(element.children[0])
  } else {
    target.push(element)
  }
  target.forEach(item => { item.setAttribute(scopedId, '') })
})

Vue.prototype.$ifnull = function(text, notNull, defaultText = '--') {
  if (text === null || text === undefined || text === '') {
    return defaultText
  }
  if (notNull) {
    return notNull(text)
  }
  return text
}

Vue.prototype.$autoSuffix = function(text, suffix = '', defaultText) {
  return Vue.prototype.$ifnull(text, s => s + suffix, defaultText)
}
Vue.prototype.$autoPrefix = function(text, prefix = '', defaultText) {
  return Vue.prototype.$ifnull(text, s => prefix + s, defaultText)
}


Vue.directive('drag', (el) => {
  const oDiv = el // 当前元素
  const minTop = oDiv.getAttribute('drag-min-top')
  const ifMoveSizeArea = 20
  oDiv.onmousedown = e => {
    let target = oDiv
    while (window.getComputedStyle(target).position !== 'absolute' && target !== document.body) {
      target = target.parentElement
    }

    document.onselectstart = () => {
      return false
    }
    if (!target.getAttribute('init_x')) {
      target.setAttribute('init_x', target.offsetLeft)
      target.setAttribute('init_y', target.offsetTop)
    }

    const initX = parseInt(target.getAttribute('init_x'))
    const initY = parseInt(target.getAttribute('init_y'))

    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - target.offsetLeft
    const disY = e.clientY - target.offsetTop
    document.onmousemove = e => {
      // 通过事件委托，计算移动的距离
      // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
      const l = e.clientX - disX
      const t = e.clientY - disY
      // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
      target.style.left = l + 'px'
      target.style.top = (t < minTop ? minTop : t) + 'px'
      if (Math.abs(l - initX) > ifMoveSizeArea || Math.abs(t - initY) > ifMoveSizeArea) {
        target.setAttribute('draged', '')
      } else {
        target.removeAttribute('draged')
      }
    }
    document.onmouseup = e => {
      document.onmousemove = null
      document.onmouseup = null
      document.onselectstart = null
    }
    // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
    return false
  }
})

function latNe(lat) {
  if (Math.abs(lat) > 90) { return '' }

  var _latNe = String(lat)

  if (_latNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _latNe = _latNe + '.000'
  }

  var tmpindex = _latNe.lastIndexOf('.')
  var preNum = Number(_latNe.substring(0, tmpindex))
  var lastNum = Number('0.' + _latNe.substring(tmpindex + 1, _latNe.length)) * 60
  if (Math.abs(preNum) > 90) { // 纬度大于 90
    return 'invalid  position'
  }

  if (lat >= 0) {
    return preNum.toString() + '-' + Fixed(lastNum.toFixed(3), 6, '0') + 'N'
  } else {
    return Math.abs(preNum) + '-' + Fixed(lastNum.toFixed(3), 6, '0') + 'S'
  }
}
function lngNe(lng) {
  lng = lng > 180 ? (lng - 360) : lng
  if (Math.abs(lng) > 180) return ''

  var _lngNe = String(lng)

  if (_lngNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _lngNe = _lngNe + '.000'
  }

  var tmpindex = _lngNe.lastIndexOf('.')
  var preNum = Number(_lngNe.substring(0, tmpindex))
  var lastNum = Number('0.' + _lngNe.substring(tmpindex + 1, _lngNe.length)) * 60
  if (Math.abs(preNum) > 180) { // 纬度大于 180
    return 'invalid  position'
  }
  if (lng >= 0) {
    return preNum.toString() + '-' + Fixed(lastNum.toFixed(3), 6, '0') + 'E '
  } else {
    return Math.abs(preNum) + '-' + Fixed(lastNum.toFixed(3), 6, '0') + 'W '
  }
}

function latNe2(lat) {
  if (Math.abs(lat) > 90) { return '' }

  var _latNe = String(lat)

  if (_latNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _latNe = _latNe + '.000'
  }

  var tmpindex = _latNe.lastIndexOf('.')
  var preNum = Number(_latNe.substring(0, tmpindex))
  var lastNum = Number('0.' + _latNe.substring(tmpindex + 1, _latNe.length)) * 60
  if (Math.abs(preNum) > 90) { // 纬度大于 90
    return 'invalid  position'
  }

  if (lat >= 0) {
    return preNum.toString() + '°' + Fixed(lastNum.toFixed(3), 6, '0') + 'N'
  } else {
    return Math.abs(preNum) + '°' + Fixed(lastNum.toFixed(3), 6, '0') + 'S'
  }
}
function lngNe2(lng) {
  lng = lng > 180 ? (lng - 360) : lng
  if (Math.abs(lng) > 180) return ''

  var _lngNe = String(lng)

  if (_lngNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _lngNe = _lngNe + '.000'
  }

  var tmpindex = _lngNe.lastIndexOf('.')
  var preNum = Number(_lngNe.substring(0, tmpindex))
  var lastNum = Number('0.' + _lngNe.substring(tmpindex + 1, _lngNe.length)) * 60
  if (Math.abs(preNum) > 180) { // 纬度大于 180
    return 'invalid  position'
  }
  if (lng >= 0) {
    return preNum.toString() + '°' + Fixed(lastNum.toFixed(3), 6, '0') + 'E '
  } else {
    return Math.abs(preNum) + '°' + Fixed(lastNum.toFixed(3), 6, '0') + 'W '
  }
}

function latNe3(lat) {
  if (Math.abs(lat) > 90) { return '' }

  var _latNe = String(lat)

  if (_latNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _latNe = _latNe + '.000'
  }

  if (lat >= 0) {
    return Fixed(parseFloat(_latNe).toFixed(3)) + 'N'
  } else {
    return Fixed(parseFloat(_latNe).toFixed(3)) + 'S'
  }
}
function lngNe3(lng) {
  lng = lng > 180 ? (lng - 360) : lng
  if (Math.abs(lng) > 180) return ''
  var _lngNe = String(lng)

  if (_lngNe.lastIndexOf('.') === -1) { // 如果数值没有小数点，则补充三个0
    _lngNe = _lngNe + '.000'
  }
  if (lng >= 0) {
    return Fixed(parseFloat(_lngNe).toFixed(3)) + 'E '
  } else {
    return Fixed(parseFloat(_lngNe).toFixed(3)) + 'W '
  }
}

function Fixed(input, length, chart) {
  var ret = input.slice(0, length)

  for (var i = 0; i < length - ret.length; i++) {
    ret = chart + ret
  }
  return ret
}

Vue.prototype.$lngNe = lngNe
Vue.prototype.$lngNe2 = lngNe2
Vue.prototype.$lngNe3 = lngNe3
Vue.prototype.$latNe = latNe
Vue.prototype.$latNe2 = latNe2
Vue.prototype.$latNe3 = latNe3


import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
VXETable.use(VXETablePluginExportXLSX)
Vue.use(VXETable)

new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  render: function (h) { return h(App) }
}).$mount('#app')
